import { useQuery } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * React Query hook for fetching user's answers
 * @param {string} userId - User ID
 * @param {boolean} enabled - Whether the query should run
 */
export const useAnswersQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["answers", userId],
    queryFn: async () => {
      const res = await api.get("/users/me/answers");
      return res.data.answers || [];
    },
    enabled: enabled && !!userId,
  });
};
